import React from "react";

// Extract Instagram post shortcode from URLs like:
//   https://www.instagram.com/p/{shortcode}/
//   https://www.instagram.com/reel/{shortcode}/
//   https://www.instagram.com/tv/{shortcode}/
function extractShortcode(url) {
  if (!url) return null;
  const m = url.match(/instagram\.com\/(?:p|reel|tv)\/([A-Za-z0-9_-]+)/);
  return m ? m[1] : null;
}

export default function InstagramEmbed({ url, captioned = false }) {
  const code = extractShortcode(url);
  if (!code) return null;
  const src = `https://www.instagram.com/p/${code}/embed/${captioned ? "captioned/" : ""}`;
  return (
    <div className="overflow-hidden border border-border rounded-sm bg-card relative" style={{ aspectRatio: "1 / 1.2" }}>
      <iframe
        src={src}
        title={`Instagram post ${code}`}
        loading="lazy"
        scrolling="no"
        allowtransparency="true"
        frameBorder="0"
        className="absolute inset-0 w-full h-full"
        style={{ background: "transparent" }}
      />
    </div>
  );
}
